function Footer() {
  return (
    <footer>
      <p>“Technology is best when it brings people together, 
    solves real-world problems, and inspires continuous learning.”</p>
    </footer>
  );
}
export default Footer;